import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0abd423a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "clock-number" }
const _hoisted_3 = { class: "clock-number" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return ($setup.show)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["shutdown-banner text-center font-Baloo-Regular", { 'shutdown-banner-critical': $setup.isShutDown }])
      }, [
        ($setup.isShutDown)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" 🔥 " + _toDisplayString(_ctx.$t("shutdown.banner.critical")), 1)
            ], 64))
          : ($setup.loaded)
            ? _withDirectives((_openBlock(), _createElementBlock("span", {
                key: 1,
                title: _ctx.$t('shutdown.banner.startedTooltip', { date: $setup.startDateLabel })
              }, [
                _createTextVNode(" ⏳ " + _toDisplayString(_ctx.$t("shutdown.banner.countdownPrefix")) + " ", 1),
                _createElementVNode("span", _hoisted_2, _toDisplayString($setup.formattedRemaining), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("shutdown.banner.countdownMiddle")) + " ", 1),
                _createElementVNode("span", _hoisted_3, "+" + _toDisplayString($setup.bonusHoursLabel) + "h", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("shutdown.banner.countdownSuffix")), 1)
              ], 8, _hoisted_1)), [
                [_directive_tooltip]
              ])
            : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}